import { render } from "./ProducedGasPressureChart.vue?vue&type=template&id=33a60104"
import script from "./ProducedGasPressureChart.vue?vue&type=script&lang=js"
export * from "./ProducedGasPressureChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__